import { useRef, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Player from "@vimeo/player";
import Header from "../header";
import { LogoImage, VectorImage, CheckImage, logo } from "../imagepath";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import BackgroundVideo from "../backgroundVideo";
import PopUp from "../popUp";
import MessageToggle from "../messageToogle";
// import Loginbg from "../../assets/img/banner.png";
// import BgBanner1 from "../../assets/img/bg-banner-01.png";
// import BgBanner2 from "../../assets/img/bg-banner-02.png";
// import Loginbg from "../../assets/img/banner.png";
// import UserLove from "../../assets/img/user-love.jpg";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import styles from "./index.module.css";
import AuthServices from "../../services/AuthServices";

export const Home = () => {
  const mobileSidebar = useSelector((state) => state.sidebarSlice.expandMenu);
  const [showNewMessage, setShowNewMessage] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);
  // useEffect(() => {
  //   console.log(mobileSidebar,'gg');

  // }, [mobileSidebar]);

  const iframeRef = useRef(null);
  const playerRef = useRef(null);
  const iframeRef1 = useRef(null);
  const playerRef1 = useRef(null);
  const iframeRef2 = useRef(null);
  const playerRef2 = useRef(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [isSecondPlaying, setIsSecondPlaying] = useState(true);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

  useEffect(() => {
    if (iframeRef.current) {
      playerRef.current = new Player(iframeRef.current);
    }
    if (iframeRef1.current) {
      playerRef1.current = new Player(iframeRef1.current);
    }
    if (iframeRef2.current) {
      playerRef2.current = new Player(iframeRef2.current);
    }
  }, []);

  const handlePlay1 = () => {
    playerRef1.current?.play();
    setIsSecondPlaying(false);
  };

  const handlePause1 = () => {
    playerRef1.current?.pause();
    setIsSecondPlaying(true);
  };

  const handleCaptchaChange = (value) => {
    if (value) {
      setIsCaptchaVerified(true);
    }
  };
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSendMessage = async (e) => {
    if (!isCaptchaVerified) return;

    e.preventDefault();

    try {
      const response = await AuthServices.sendEmail(formData);
      console.log("response", response);
      Swal.fire({
        title: "Success!",
        text: "Sucessfully Sent!",
        icon: "success",
        confirmButtonText: "OK",
      });
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      Swal.fire({
        text: "Failed to Send!",
        icon: "info",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <>
      <MessageToggle
        showMessage={showNewMessage}
        handleClose={() => setShowNewMessage(false)}
      />
      <PopUp></PopUp>
      <div className="main-wrapper">
        <Header />
        <div
          className={`d-flex justify-content-center align-items-center ${styles.main_body}`}
        >
          <BackgroundVideo />
          <div
            className={`d-flex flex-row position-absolute align-items-center ${styles.displayBlock}`}
          >
            <img className={`${styles.logoImage}`} src={LogoImage} />
            <div className="d-flex flex-column">
              <p className={`${styles.topTitle}`}>Prepare. Protect. Prevent</p>
              <p className={`${styles.bottomTitle}`}>
                The Only Emergency Training That Has Saved Lives
              </p>
            </div>
          </div>
        </div>

        <div className={styles.hardTruthMeaning}>
          {/* <p className={styles.hardTruthMeaningSubText}>
            If your staff isn’t trained to react immediately, they are
            defenseless,
          </p> */}
          <p className={styles.hardTruthMeaningTitle}>
            The Only National Accredited Emergency Certification and Management
            System for Schools and Daycares
          </p>
          <p className={styles.hardTruthMeaningSubText}>
            Interactive. On-Demand. Backed by the U.S. Government. Now Available
            to You.
          </p>
          <p className={styles.hardTruthMeaningText}>Why 97% Fail Audits</p>
          <p className={styles.hardTruthMeaningSubText}>
            97% of schools and daycares fail their emergency protocol audits due
            to outdated or incomplete safety procedures. AngelWatch was built
            specifically to address this alarming failure rate. The issue isn’t
            lack of effort—it’s lack of access. Most centers are given vague
            requirements without clear guidance. AngelWatch delivers a complete,
            ready-to-implement solution that provides clarity, structure, and
            real protection.
          </p>
          <Link to="/getCertified">
            <button
              className="w-auto mt-2 fs-5 p-3 rounded-4"
              style={{ backgroundColor: "crimson" }}
            >
              Protect Your School Now -&gt;
            </button>
          </Link>
        </div>
        <section
          className={`d-flex flex-column align-items-center ${styles.whatDifferent}`}
        >
          <div className={`d-flex flex-row justify-content-between`}>
            <div
              className={styles.whatDifferentLeft}
              style={{
                width: "600px",
                marginTop: "auto",
                marginBottom: "auto",
              }}
            >
              <section
                className={`d-flex flex-column align-items-center`}
                style={{
                  width: "100%",
                  backgroundColor: "#0D5EF4",
                  borderRadius: "16px",
                }}
              >
                <iframe
                  ref={iframeRef1}
                  src="https://player.vimeo.com/video/1078781366?controls=0&title=0&byline=0&portrait=0"
                  allow="autoplay; picture-in-picture"
                  style={{ width: "100%", height: "360px", padding: "12px" }}
                ></iframe>
                <div
                  className={`d-flex gap-2 mt-3 justify-content-center ${styles.youtube__button}`}
                  style={{ alignSelf: "center" }}
                >
                  {isSecondPlaying ? (
                    <button
                      onClick={handlePlay1}
                      className={`btn btn-primary ${styles.youtube__button__width}`}
                    >
                      <img
                        src={require("../../assets/img/playIcon.png")}
                        style={{ width: "50%" }}
                      ></img>
                    </button>
                  ) : (
                    <button
                      onClick={handlePause1}
                      className={`btn btn-primary ${styles.youtube__button__width}`}
                    >
                      <img
                        src={require("../../assets/img/pauseIcon.png")}
                        style={{ width: "50%" }}
                      ></img>
                    </button>
                  )}
                </div>
                <div>
                  <p
                    className="text-center text-white"
                    style={{ fontSize: "40px" }}
                  >
                    100% Tax Deductible
                  </p>
                </div>
              </section>
            </div>
            <div className={styles.whatDifferentRight}>
              <p className={styles.whatDifferentRightTitle}>
                Why Schools and Daycares Trust AngelWatch
              </p>
              <p className={styles.whatDifferentRightSubTitle}>
                Hundreds of Schools and Child Care Centers Rely on AngelWatch to
                Protect Students and Meet State Compliance Standards.
              </p>

              <div className={styles.whatDifferentCard}>
                <img className={styles.whatDifferentImage} src={VectorImage} />
                <div className={styles.blueBar}></div>
                <div className={styles.whatDifferentCardMain}>
                  <img
                    className={styles.whatDifferentCardMainImage}
                    src={CheckImage}
                  />
                  <div className="d-flex flex-column">
                    <span className={styles.whatDifferentCardTitle}>
                      Complete Emergency Management System
                    </span>
                    <p className={styles.whatDifferentCardText}>
                      with built-in compliance support
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles.whatDifferentCard}>
                <img className={styles.whatDifferentImage} src={VectorImage} />
                <div className={styles.blueBar}></div>
                <div className={styles.whatDifferentCardMain}>
                  <img
                    className={styles.whatDifferentCardMainImage}
                    src={CheckImage}
                  />
                  <div className="d-flex flex-column">
                    <span className={styles.whatDifferentCardTitle}>
                      Unlimited staff training and recertification
                    </span>
                    <p className={styles.whatDifferentCardText}>
                      for a full year
                    </p>
                  </div>
                </div>
              </div>

              <div className={styles.whatDifferentCard}>
                <img className={styles.whatDifferentImage} src={VectorImage} />
                <div className={styles.blueBar}></div>
                <div className={styles.whatDifferentCardMain}>
                  <img
                    className={styles.whatDifferentCardMainImage}
                    src={CheckImage}
                  />
                  <div className="d-flex flex-column">
                    <span className={styles.whatDifferentCardTitle}>
                      Real-world, interactive
                    </span>
                    <p className={styles.whatDifferentCardText}>
                      scenario-based testing
                    </p>
                  </div>
                </div>
              </div>

              <div className={styles.whatDifferentCard}>
                <img className={styles.whatDifferentImage} src={VectorImage} />
                <div className={styles.blueBar}></div>
                <div className={styles.whatDifferentCardMain}>
                  <img
                    className={styles.whatDifferentCardMainImage}
                    src={CheckImage}
                  />
                  <div className="d-flex flex-column">
                    <span className={styles.whatDifferentCardTitle}>
                      Free Emergency Protocol Handbook
                    </span>
                    <p className={styles.whatDifferentCardText}>
                      written to meet state standards
                    </p>
                  </div>
                </div>
              </div>

              <div className={styles.whatDifferentCard}>
                <img className={styles.whatDifferentImage} src={VectorImage} />
                <div className={styles.blueBar}></div>
                <div className={styles.whatDifferentCardMain}>
                  <img
                    className={styles.whatDifferentCardMainImage}
                    src={CheckImage}
                  />
                  <div className="d-flex flex-column">
                    <span className={styles.whatDifferentCardTitle}>
                      Pre-written, plug-and-play SOPs
                    </span>
                    <p className={styles.whatDifferentCardText}>
                      to instantly meet state inspection requirements
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles.whatDifferentCard}>
                <img className={styles.whatDifferentImage} src={VectorImage} />
                <div className={styles.blueBar}></div>
                <div className={styles.whatDifferentCardMain}>
                  <img
                    className={styles.whatDifferentCardMainImage}
                    src={CheckImage}
                  />
                  <div className="d-flex flex-column">
                    <span className={styles.whatDifferentCardTitle}>
                      Full staff tracking dashboard
                    </span>
                    <p className={styles.whatDifferentCardText}>
                      with certification monitoring
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles.whatDifferentCard}>
                <img className={styles.whatDifferentImage} src={VectorImage} />
                <div className={styles.blueBar}></div>
                <div className={styles.whatDifferentCardMain}>
                  <img
                    className={styles.whatDifferentCardMainImage}
                    src={CheckImage}
                  />
                  <div className="d-flex flex-column">
                    <span className={styles.whatDifferentCardTitle}>
                      No hidden fees, per-user licenses
                    </span>
                    <p className={styles.whatDifferentCardText}>
                      or surprise charges
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <p style={{ width: "90%" }}>
            AngelWatch is not just another training course. It’s the only
            emergency certification system in the country that is copyrighted,
            trademarked, and patented—designed specifically to preserve the
            integrity of our protocols and ensure the highest standard of
            protection. Unlike traditional safety courses that rely on passive
            video learning, AngelWatch places educators and staff into
            interactive emergency scenarios that require them to respond and
            pass tests in order to be certified. The platform also manages
            documentation, alerts, recertification timelines, and compliance
            tracking—all from one dashboard.
          </p>

          <div
            className="d-block d-lg-flex gap-5 mt-4"
            style={{ width: "90%" }}
          >
            <div
              className="w-100 w-lg-50 p-4 text-center m-2"
              style={{ backgroundColor: "#00112B", borderRadius: "20px" }}
            >
              <p
                className={`${styles.hardTruthMeaningText}`}
                style={{
                  width: "fit-content",
                  padding: "20px",
                  justifySelf: "center",
                }}
              >
                How It Works
              </p>
              <p
                className={styles.hardTruthMeaningSubText}
                style={{ justifySelf: "center", lineHeight: "2" }}
              >
                AngelWatch is easy to implement and powerful in execution.
                Administrators assign training access, staff complete the course
                at their own pace, and the system ensures every person is
                tested, certified, and documented. All data is accessible in a
                secure dashboard, making audits and licensing inspections simple
                to manage. Staff onboarding takes just minutes, and all records
                are stored in one place with auto-alerts for recertification.
              </p>
              <Link to="/include">
                <button
                  className="w-auto mt-2 fs-5 p-4 rounded-4"
                  style={{ backgroundColor: "#0D5EF4" }}
                >
                  What is Included -&gt;
                </button>
              </Link>
            </div>
            <div
              className="w-100 w-lg-50 p-4 text-center m-2"
              style={{ backgroundColor: "#00112B", borderRadius: "20px" }}
            >
              <p
                className={styles.hardTruthMeaningText}
                style={{
                  width: "max-content",
                  padding: "20px",
                  justifySelf: "center",
                }}
              >
                Partnerships & Accreditation
              </p>
              <p
                className={styles.hardTruthMeaningSubText}
                style={{ lineHeight: "2" }}
              >
                AngelWatch is the only national safety accreditation program
                built exclusively for early childhood and educational
                facilities.
              </p>
              <p className="text-center text-white">
                Our program is partnered with:
              </p>
              <div className="d-block d-lg-flex justify-content-center align-items-center gap-5 text-center">
                <img
                  src={require("../../assets/img/American-Red-Cross.png")}
                  style={{ width: "200px", height: "fit-content" }}
                />
                <img
                  src={require("../../assets/img/American-Heart-Association-1.png")}
                  style={{ width: "200px", height: "fit-content" }}
                />
              </div>
              <p className="text-center text-white">And backed by:</p>
              <div className="text-center">
                <img
                  src={require("../../assets/img/Seal_of_the_United_States_Department_of_Homeland_Security.svg.png")}
                  style={{ width: "200px", height: "fit-content" }}
                />
              </div>
            </div>
          </div>
          <div className="d-flex gap-5 m-4">
            <Link to="/testimonial">
              <button
                className="w-auto mt-2 fs-5 p-4 rounded-4"
                style={{ backgroundColor: "#0D5EF4" }}
              >
                What Customers are Saying -&gt;
              </button>
            </Link>
            <Link to="/faq">
              <button
                className="w-auto mt-2 fs-5 p-4 rounded-4"
                style={{ backgroundColor: "#0D5EF4" }}
              >
                Frequently Asked Questions -&gt;
              </button>
            </Link>
          </div>
          <p className={`mt-5 ${styles.certificationTitle1}`}>
            🔹 These aren’t symbolic affiliations—they ensure our course meets
            national safety standards and can be trusted to protect students,
            staff, and school leadership.
          </p>
          <div className={styles.cta}>
            <h1 className={`text-white ${styles.cta__title}`}>
              Protect your children. Protect your staff. Stay compliant.
            </h1>
            <Link to="getCertified">
              <button className={styles.cta__button}>
                Get Certified Now -&gt;
              </button>
            </Link>
          </div>
        </section>

        <section className={styles.contact__section}>
          <h1 className={styles.contact__heading}>Contact Us</h1>
          <div className={styles.contact}>
            <div>
              <h2 className={styles.contact__title}>
                For more information contact us
              </h2>
              <div>
                <img src={LogoImage} className={styles.contact__logoImg}></img>
              </div>
              <div>
                <div className={styles.contact__list}>
                  <img
                    src={require("../../assets/img/email.png")}
                    className={styles.contact__img}
                  ></img>
                  <p
                    className={styles.contact__item}
                    onClick={() => {
                      setShowNewMessage(true);
                      console.log("showmessage", showNewMessage);
                    }}
                  >
                    Edu@AngelWatch.org
                  </p>
                </div>
                <div className={styles.contact__list}>
                  <img
                    src={require("../../assets/img/call.png")}
                    className={styles.contact__img}
                  ></img>
                  <p className={styles.contact__item}>+1 800-381-6794</p>
                </div>
              </div>
            </div>
            <div className={styles.contact__form}>
              <div>
                <p>Your name</p>
                <input
                  type="text"
                  className={styles.contact__input__info}
                  placeholder="John Smith"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                ></input>
              </div>
              <div>
                <p>Your email</p>
                <input
                  type="email"
                  name="email"
                  className={styles.contact__input__info}
                  placeholder="abc@gmail.com"
                  value={formData.email}
                  onChange={handleChange}
                ></input>
              </div>
              <div className={styles.contact__message__form}>
                <p>Your message</p>
                <textarea
                  type="text"
                  name="message"
                  className={styles.contact__message__input}
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
              </div>
              <button
                style={{ marginBottom: "20px" }}
                onClick={handleSendMessage}
                disabled={!handleCaptchaChange}
              >
                Send Message
              </button>
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_SITE_KEY}
                onChange={handleCaptchaChange}
                className={`${styles.captcha}`}
              />
            </div>
          </div>
        </section>

        {/* Master Skills */}
        {/* /Master Skills */}
        <section className="d-flex flex-column">
          <div className={styles.footerTop}>
            <div className={styles.footerSection}>
              <img className={styles.footerImage} src={logo} />
              <p className={styles.footerDes}>
                All of our techniques, trainings, equipment, software, hardware,
                and instructional materials are classified and proprietary to
                the AngelWatch Foundation. We do not publicly disclose our
                teaching methodologies. This confidentiality is essential to
                ensure the ongoing safety and security of our centers, staff,
                and the children entrusted to our care. By continuously
                improving, adapting, and evolving our systems, we remain one
                step ahead—proactively closing any potential gaps and ensuring
                every base is covered.
              </p>
            </div>

            <div className={styles.footerLoginSection}>
              <p className={styles.footerTitle}>School</p>
              <Link to="/login">
                <a className={styles.footerLink1}>Login</a>
              </Link>
              <Link to="/selectregister">
                <a className={styles.footerLink1}>Register</a>
              </Link>
            </div>

            <div className={styles.footerSection}>
              <p className={styles.footerTitle}>Newsletter</p>
              <input
                className={styles.newsLetter}
                placeholder="Enter your email address"
                type="text"
              />
              <p className={styles.footerLink1}>
                Hampton Reserve Drive, Brentwood tennessee, 37027
              </p>
              <p
                className={styles.footerLink1}
                onClick={() => {
                  setShowNewMessage(true);
                  console.log("showmessage", showNewMessage);
                }}
              >
                Edu@AngelWatch.org
              </p>
              <p className={styles.footerLink1}>+1 800-381-6794</p>
            </div>
          </div>
          <div className={styles.footerBottom}>
            <div className={styles.footerBottomLeft}>
              <p className={styles.footerLink}>Term</p>
              <p className={styles.footerLink}>|</p>
              <p className={styles.footerLink}>Privacy</p>
            </div>
            <div className={styles.footerBottomRight}>
              <p className={styles.footerLink}>
                © 2025 AngelWatch LMS. All rights reserved.
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Home;
